import React, { useContext, useState } from "react";
import "./Bio_Popup.scss";
import { RiPencilFill } from "react-icons/ri";
import { HiPlus } from "react-icons/hi";
import { UserContext } from "../../Context";
import { sellerApi } from "../../utils/Api";
import { toast } from "react-toastify";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const Bio_Popup = ({ setBio_pop }) => {
    const { user } = useContext(UserContext);

    const [biography, setBiography] = useState(user?.biography || "");
    const [access, setAccess] = useState({
        edit: false,
        add: false
    })

    const updateBio = async () => {
        try {
            const response = await sellerApi.put(`/api/seller/editSellerBio?bioId=${user?.id}`, {
                biography: biography
            });

            if (response.status === 200) {
                setAccess({ ...access, add: false, edit: false });
                setBio_pop(false)
                setBiography(response.data.biography);
                toast.success("Biography updated successfully");
                window.location.reload();

            }
        } catch (error) {
            console.log(error)
        }
    }


    const addBio = async () => {
        try {
            const response = await sellerApi.post(`api/seller/addSellerBio`, {
                sellerId: user?.sellerId,
                biography: biography
            });

            if (response.status === 200) {
                setAccess({ ...access, add: false, edit: false });
                setBio_pop(false)
                setBiography(response.data.biography);
                toast.success("Biography added successfully");
                window.location.reload();

            }
        } catch (error) {
            console.log(error);
        }
    }




    return (
        <>
            <div class="bio_popup_parent parent">
                <div class="overlay" onClick={() => setBio_pop(false)}></div>
                <div class="bio_pop_box">
                    {user?.biography &&
                        <>
                            {(user?.biography && access.edit) ? <div class="btn su_btn" onClick={updateBio} >
                                Update
                            </div>
                                :
                                <div class="edit_btn" onClick={() => setAccess({ ...access, edit: true })} >
                                    <RiPencilFill />
                                </div>}
                        </>


                    }
                    {!user?.biography &&
                        <>
                            {!access.add ? <div class="edit_btn" onClick={() => setAccess({ ...access, add: true })}   >
                                <HiPlus />
                            </div>
                                :
                                <div class="btn su_btn" onClick={addBio}  >

                                    ADD
                                </div>}
                        </>


                    }


                    <h2>About Me</h2>
                    {access.add ? (
                        <>
                            <CKEditor
                                editor={ClassicEditor}
                                data={biography}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setBiography(data);
                                }}
                            />
                        </>
                    ) : (
                        <>
                            {(user?.biography && access.edit) ? (
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={biography}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        setBiography(data);
                                    }}
                                />
                            ) : (
                                <div
                                    dangerouslySetInnerHTML={{ __html: user?.biography }}
                                />
                            )}
                        </>
                    )}




                </div>
            </div>
        </>
    );
};

export default Bio_Popup;
